import { Button, FileUploadTrigger } from "@wayflyer/flyui";
import type { UseUploadManagerReturn } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { BANK_STATEMENT_ACCEPTED_FILE_TYPES, UPLOAD_STATEMENTS_SIZE_LIMIT_MB } from "../../../../components/constants";

import type { BankStatementUpload } from "../../hooks/use-bank-accounts-upload-manager";

import { MESSAGES } from "../message-definitions";

type AddStatementsButtonProps = {
  onFilesAdded: UseUploadManagerReturn<BankStatementUpload>["onFilesAdded"];
  fullWidth?: boolean;
  disabled?: boolean;
  /**
   * Disable while another dropzone (e.g. a side panel's) is open, so this page-wide dropzone
   * doesn't intercept a drop meant for the smaller, scoped one.
   * @default true
   */
  fullScreenDropzone?: boolean;
};

export const AddStatementsButton = ({
  fullWidth,
  disabled,
  onFilesAdded,
  fullScreenDropzone = true,
}: AddStatementsButtonProps) => {
  const intl = useIntl();

  return (
    <FileUploadTrigger
      onFilesAdded={onFilesAdded}
      acceptedFileTypes={BANK_STATEMENT_ACCEPTED_FILE_TYPES}
      sizeLimitMB={UPLOAD_STATEMENTS_SIZE_LIMIT_MB}
      testId="banking-accounts-statements"
      disabled={disabled}
      fullScreenDropzone={fullScreenDropzone}
      trigger={({ open, disabled: triggerDisabled }) => (
        <Button variant="Tertiary" fullWidth={fullWidth} onClick={open} disabled={disabled || triggerDisabled}>
          {intl.formatMessage(MESSAGES.addStatementsManually)}
        </Button>
      )}
    />
  );
};
